import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {SourceResolved} from "../source-resolver.service";

const simbadUrl = 'https://simbad.u-strasbg.fr/simbad/sim-id?NbIdent=1&Ident=';
const nedUrl = 'https://nedwww.ipac.caltech.edu/cgi-bin/nph-objsearch?extend=no&objname=';
const vizierUrl = 'https://vizier.u-strasbg.fr/viz-bin/VizieR?-source=&-out.add=_r&-out.add=_RAJ%2C_DEJ&-sort=_r&-to=&-out.max=20&-meta.ucd=2&-meta.foot=1&-c.rs=10&-c=';

@Component({
  selector: 'lib-source-resolver-info',
  templateUrl: './source-resolver-info.component.html',
  styles: [`
    .square-container {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      border-radius: 4px;
    }
    .principle-row-padding {
      padding-bottom: 5px;  
    }
    .secondary-row-padding {
      padding-bottom: 15px;  
    }  
    `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SourceResolverInfoComponent {
  @Input() sourceResolved: SourceResolved;

  getSimbadUrl() {
    return `${simbadUrl}${this.sourceResolved?.oName}`;
  }

  getNedUrl() {
    return `${nedUrl}${this.sourceResolved?.oName}`;
  }

  getVizierUrl() {
    return`${vizierUrl}${this.sourceResolved?.oName}`;
  }
}
